// "What's Selling" ticker refresh. The list is server-rendered by
// shared/_whats_selling; a `data-poll` (seconds) on `.js-whats-selling` opts that
// placement into re-fetching /whats-selling.json and re-rendering the list.
import { createStatusPoller } from "../live_status"

const SELECTOR = ".js-whats-selling[data-poll]"
const MIN_INTERVAL_SECONDS = 30
// Stop 30 minutes after page load so a forgotten tab doesn't poll all day.
const MAX_POLL_MINUTES = 30

let pollers = []

function timeAgo(iso) {
  const minutes = Math.max(
    0,
    Math.round((Date.now() - Date.parse(iso)) / 60000)
  )
  if (minutes < 1) return "just now"
  if (minutes < 60)
    return minutes + (minutes === 1 ? " minute ago" : " minutes ago")
  const hours = Math.round(minutes / 60)
  if (hours < 24) return hours + (hours === 1 ? " hour ago" : " hours ago")
  const days = Math.round(hours / 24)
  return days + (days === 1 ? " day ago" : " days ago")
}

function link(url, child) {
  const a = document.createElement("a")
  a.href = url
  a.appendChild(child)
  return a
}

// Built with DOM nodes and textContent: titles are creator-supplied text.
function renderItem(item) {
  const li = document.createElement("li")
  li.className = "d-flex align-items-center gap-2 mb-2"

  const img = document.createElement("img")
  img.src = item.image_url
  img.alt = item.title
  img.width = 60
  img.loading = "lazy"
  li.appendChild(link(item.url, img))

  li.appendChild(link(item.url, document.createTextNode(item.title)))

  const price = document.createElement("span")
  price.textContent = item.price_display
  li.appendChild(price)

  const time = document.createElement("time")
  time.dateTime = item.sold_at
  time.textContent = timeAgo(item.sold_at)
  li.appendChild(time)

  return li
}

function init(el) {
  const seconds = Math.max(
    MIN_INTERVAL_SECONDS,
    parseInt(el.dataset.poll, 10) || 0
  )
  const list = el.querySelector(".js-whats-selling-list")
  // start() resets the poller's budget, so resume() on tab switches would
  // extend it; a fixed deadline caps the lifetime from page load instead.
  const deadline = Date.now() + MAX_POLL_MINUTES * 60 * 1000
  const poller = createStatusPoller({
    page: () => (document.body.contains(el) ? el : null),
    hasPending: () => !document.hidden && Date.now() < deadline,
    url: () => el.dataset.url,
    interval: seconds * 1000,
    maxPolls: Math.ceil((MAX_POLL_MINUTES * 60) / seconds),
    onResults: (items) => {
      list.replaceChildren(...items.map(renderItem))
      return false
    },
  })
  poller.start()
  return poller
}

function initAll() {
  teardownAll()
  pollers = Array.from(document.querySelectorAll(SELECTOR)).map(init)
}

function teardownAll() {
  pollers.forEach((poller) => poller.stop())
  pollers = []
}

// A hidden tab stops scheduling polls; pick back up when it's visible again.
function resume() {
  if (!document.hidden) pollers.forEach((poller) => poller.start())
}

document.addEventListener("turbolinks:load", initAll)
document.addEventListener("turbolinks:before-cache", teardownAll)
document.addEventListener("visibilitychange", resume)
